import React,{useState,useEffect,useRef} from 'react';
import GameScreen from './GameScreen';
import StartScreen from './StartScreen';
import EndScreen from './EndScreen';
import Leaderboard from './Leaderboard';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiInfo,FiShield}=FiIcons;

const SalesHunterGame=()=> {
const [gameState,setGameState]=useState('start');// 'start','playing','ended'
const [score,setScore]=useState(0);
const [timeLeft,setTimeLeft]=useState(30);
const [leaderboard,setLeaderboard]=useState([]);
const [currentRound,setCurrentRound]=useState(1);
const gameTimer=useRef(null);

const startGame=()=> {
setScore(0);
setTimeLeft(30);
setGameState('playing');
setCurrentRound(prev=> prev + 1);
gameTimer.current=setInterval(()=> {
setTimeLeft(prev=> {
if (prev <=1) {
endGame();
return 0;
}
return prev - 1;
});
},1000);
};

const endGame=()=> {
if (gameTimer.current) {
clearInterval(gameTimer.current);
gameTimer.current=null;
}
setGameState('ended');
updateLeaderboard(score);
};

const updateLeaderboard=(newScore)=> {
const newEntry={score: newScore,round: currentRound};
setLeaderboard(prev=> {
const updated=[...prev,newEntry].sort((a,b)=> b.score - a.score).slice(0,5);
return updated;
});
};

const resetGame=()=> {
setGameState('start');
setScore(0);
setTimeLeft(30);
};

useEffect(()=> {
return ()=> {
if (gameTimer.current) {
clearInterval(gameTimer.current);
}
};
},[]);

return (
<div className="min-h-screen bg-gradient-to-b from-purple-900 via-blue-900 to-black relative overflow-hidden flex flex-col">
{/* Background elements */}
<div className="absolute inset-0 bg-black opacity-50"></div>

{/* Main content */}
<div className="flex-1 relative z-10">
{gameState==='start' && (
<StartScreen onStartGame={startGame} leaderboard={leaderboard} />
)}
{gameState==='playing' && (
<GameScreen score={score} setScore={setScore} timeLeft={timeLeft} onGameEnd={endGame} />
)}
{gameState==='ended' && (
<EndScreen score={score} onPlayAgain={startGame} onBackToStart={resetGame} />
)}
</div>

{/* Footer */}
<footer className="relative z-10 bg-black bg-opacity-70 border-t border-gray-700 py-4 px-4">
<div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4">
<div className="text-gray-400 text-sm text-center md:text-left">
© 2025 Mathias Deppe: Client Hunter Halloween Edition. All rights reserved.
</div>
<div className="flex gap-4 items-center">
<a href="https://www.mathiasdeppe.com/imprint" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors duration-200 text-sm">
<SafeIcon icon={FiInfo} />
Imprint
</a>
<a href="https://www.mathiasdeppe.com/privacy-police" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors duration-200 text-sm">
<SafeIcon icon={FiShield} />
Privacy Policy
</a>
</div>
</div>
</footer>
</div>
);
};

export default SalesHunterGame;